import { render, staticRenderFns } from "./chat-box-v2.vue?vue&type=template&id=1c6a7e4a&scoped=true"
import script from "./chat-box-v2.vue?vue&type=script&lang=js"
export * from "./chat-box-v2.vue?vue&type=script&lang=js"
import style0 from "./chat-box-v2.vue?vue&type=style&index=0&id=1c6a7e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6a7e4a",
  null
  
)

export default component.exports